import type { PropsWithChildren } from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, IconButton, Tooltip, Typography } from '@mui/material'

type ClimateControlFieldProps = PropsWithChildren<{
  label: string
  helpText?: string
}>

const ClimateControlField = ({ label, helpText, children }: ClimateControlFieldProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        minWidth: 0,
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, mb: 0.75, minHeight: 18 }}>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{
            display: 'block',
            fontWeight: 700,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            lineHeight: 1.2,
          }}>
          {label}
        </Typography>
        {helpText && (
          <Tooltip title={helpText} arrow enterTouchDelay={0}>
            <IconButton
              size="small"
              aria-label={`${label} help`}
              sx={{
                p: 0.25,
                color: 'text.secondary',
                '&:hover': {
                  color: 'text.primary',
                },
              }}>
              <InfoOutlinedIcon sx={{ fontSize: 15 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      {children}
    </Box>
  )
}

export default ClimateControlField
